import {
  CreateFirstPayrollPolicyDocument,
  CreateFirstPayrollPolicyMutation,
  CreateFirstPayrollPolicyMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export type CreatePayrollPolicyPayload =
  CreateFirstPayrollPolicyMutation['payrollMutations']['createPayrollOnboarding']

export const useCreateFirstPayrollPolicy = () => {
  const [CreatePayrollPolicy, { loading }] = useMutation(CreateFirstPayrollPolicyDocument, {
    extractorFn: (data: CreateFirstPayrollPolicyMutation) =>
      data.payrollMutations.createPayrollOnboarding,
  })

  return {
    loading,
    CreatePayrollPolicy(variables: CreateFirstPayrollPolicyMutationVariables) {
      return CreatePayrollPolicy({
        variables,
      })
    },
  }
}
